import { render, staticRenderFns } from "./w-shipment.vue?vue&type=template&id=64b01881&"
import script from "./w-shipment.vue?vue&type=script&lang=js&"
export * from "./w-shipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports